import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.agro_operations_index_page', async () => {
  const { default: Component } = await import('./internal/agro_operations_index_page');
  Component();
});

onElelementExistRunOnce('.ao-consolidated-report', async () => {
  const { default: Component } = await import('./internal/agro-operation-consolidated-report');
  Component();
});

onElelementExistRunOnce('.agro-operation-show-page', async () => {
  const { default: Component } = await import('./internal/agro-operation-show-page');
  Component();
});

// Other
const selector =
  '.agro_operations_edit_page, ' +
  '.agro-operation-show-page, ' +
  '.agro_operations_index_page, ' +
  '.field_dashboards_agro_operations';
onElelementExistRunOnce(selector, () => {
  $('.link-with-popover[data-toggle="popover"]').popover();
});
